var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-drawer",
    {
      staticStyle: {
        height: "100%",
        overflow: "auto",
        "padding-bottom": "53px"
      },
      attrs: {
        title: _vm.title,
        maskClosable: false,
        width: _vm.drawerWidth,
        placement: "right",
        closable: true,
        visible: _vm.visible
      },
      on: { close: _vm.handleCancel }
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticStyle: { width: "100%" } }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "span",
            {
              staticStyle: {
                display: "inline-block",
                width: "calc(100% - 51px)",
                "padding-right": "10px",
                "text-align": "right"
              }
            },
            [
              _c("a-button", {
                staticStyle: { height: "20px", width: "20px", border: "0px" },
                attrs: { icon: "appstore" },
                on: { click: _vm.toggleScreen }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["column.jobNumber"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "workNo"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: _vm.language["warning.jobNumberRequired"],
                      readOnly: !!_vm.model.id,
                      maxLength: _vm.maxLength.workNo
                    },
                    model: {
                      value: _vm.model.workNo,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "workNo", $$v)
                      },
                      expression: "model.workNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.userName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "realname"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: _vm.language["user.pleaseSetRealname"],
                      maxLength: _vm.maxLength.realname
                    },
                    model: {
                      value: _vm.model.realname,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "realname", $$v)
                      },
                      expression: "model.realname"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["employee.column.englishName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["employee.column.englishName"],
                      maxLength: 40
                    },
                    model: {
                      value: _vm.model.englishName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "englishName", $$v)
                      },
                      expression: "model.englishName"
                    }
                  })
                ],
                1
              ),
              _vm.model.isUser === "1"
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["PlatForm.employee.columns.depart"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", icon: "search" },
                              on: { click: _vm.toSelectDeport }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.language["PlatForm.employee.chooseDepart"]
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.selectedApps, function(item, index) {
                        return !_vm.boo && item.selectedDepartNames
                          ? _c("div", { key: index, attrs: { value: item } }, [
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "900" } },
                                [_vm._v(_vm._s(item.applicationName))]
                              ),
                              _vm._v(
                                " : " +
                                  _vm._s(item.selectedDepartNames) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      }),
                      _vm._l(_vm.newselectedApps, function(item, index) {
                        return _vm.boo && item.selectedDepartNames
                          ? _c("div", { key: index, attrs: { value: item } }, [
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "900" } },
                                [_vm._v(_vm._s(item.applicationName))]
                              ),
                              _vm._v(
                                " : " +
                                  _vm._s(item.selectedDepartNames) +
                                  "\n        "
                              )
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.Avatar"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-image-upload", {
                    staticClass: "avatar-uploader",
                    attrs: { text: _vm.language["common.uploadButton"] },
                    model: {
                      value: _vm.model.avatar,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "avatar", $$v)
                      },
                      expression: "model.avatar"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["column.gender"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: _vm.language["warning.genderRequired"],
                        getPopupContainer: function(target) {
                          return target.parentNode
                        }
                      },
                      model: {
                        value: _vm.model.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "sex", $$v)
                        },
                        expression: "model.sex"
                      }
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v(_vm._s(_vm.language["common.sex.man"]))
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v(_vm._s(_vm.language["common.sex.woman"]))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.birthday"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: _vm.language["warning.birthdayRequired"],
                      format: _vm.dateFormat,
                      getCalendarContainer: function(node) {
                        return node.parentNode
                      }
                    },
                    model: {
                      value: _vm.model.birthday,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "birthday", $$v)
                      },
                      expression: "model.birthday"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["column.mailbox"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "email"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: _vm.language["warning.emailRequired"],
                      maxLength: 60
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["column.cellphoneNumber"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: _vm.language["warning.phoneNumberIncorrect"],
                      maxLength: 20
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["column.Landline"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["warning.landlineNumberRequired"],
                      maxLength: 20
                    },
                    model: {
                      value: _vm.model.telephone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "telephone", $$v)
                      },
                      expression: "model.telephone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.position"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-select-position", {
                    attrs: {
                      placeholder:
                        _vm.language["PlatForm.employee.pleaseSetPosition"],
                      multiple: false
                    },
                    model: {
                      value: _vm.model.post,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "post", $$v)
                      },
                      expression: "model.post"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.joinDate"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      format: _vm.dateFormat,
                      getCalendarContainer: function(node) {
                        return node.parentNode
                      }
                    },
                    model: {
                      value: _vm.model.joinDate,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "joinDate", $$v)
                      },
                      expression: "model.joinDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.joinBgDate"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      format: _vm.dateFormat,
                      getCalendarContainer: function(node) {
                        return node.parentNode
                      }
                    },
                    model: {
                      value: _vm.model.joinBgDate,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "joinBgDate", $$v)
                      },
                      expression: "model.joinBgDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: _vm.language["PlatForm.employee.columns.isResigned"]
                  }
                },
                [
                  _c("a-switch", {
                    attrs: {
                      checkedChildren: _vm.language["common.yes"],
                      unCheckedChildren: _vm.language["common.no"]
                    },
                    on: { change: _vm.resignedChange },
                    model: {
                      value: _vm.model.isResigned != 0,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "isResigned!=0", $$v)
                      },
                      expression: "model.isResigned!=0"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.siteCode"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      placeholder:
                        _vm.language["PlatForm.employee.pleaseSetWorkplace"],
                      dictCode: "\twork_place"
                    },
                    model: {
                      value: _vm.model.siteCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "siteCode", $$v)
                      },
                      expression: "model.siteCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label:
                      _vm.language["PlatForm.employee.columns.educationDegree"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "educationDegree"
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      placeholder:
                        _vm.language[
                          "PlatForm.employee.pleaseSetEducationDegree"
                        ],
                      dictCode: "education_degree"
                    },
                    model: {
                      value: _vm.model.educationDegree,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "educationDegree", $$v)
                      },
                      expression: "model.educationDegree"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label:
                      _vm.language["PlatForm.employee.columns.nationality"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.nationalityChange },
                      model: {
                        value: _vm.model.nationality,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "nationality", $$v)
                        },
                        expression: "model.nationality"
                      }
                    },
                    _vm._l(_vm.nationalityRegionList, function(item, index) {
                      return _c(
                        "a-select-option",
                        {
                          key: index.toString(),
                          attrs: { value: item.id.toString() }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.name) +
                              "\n              "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.province"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      on: { change: _vm.provinceChange },
                      model: {
                        value: _vm.model.province,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "province", $$v)
                        },
                        expression: "model.province"
                      }
                    },
                    _vm._l(_vm.provinceRegionList, function(item, index) {
                      return _c(
                        "a-select-option",
                        {
                          key: index.toString(),
                          attrs: { value: item.id.toString() }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.county"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.model.county,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "county", $$v)
                        },
                        expression: "model.county"
                      }
                    },
                    _vm._l(_vm.countyRegionList, function(item, index) {
                      return _c(
                        "a-select-option",
                        {
                          key: index.toString(),
                          attrs: { value: item.id.toString() }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.address"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "address"
                  }
                },
                [
                  _c("a-input", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      placeholder:
                        _vm.language["PlatForm.employee.pleaseSetAddress"],
                      maxLength: _vm.maxLength.address
                    },
                    model: {
                      value: _vm.model.address,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "address", $$v)
                      },
                      expression: "model.address"
                    }
                  }),
                  _c(
                    "a-button",
                    {
                      staticStyle: { left: "5%" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.languageModelOpen(
                            "SysBmEmployee",
                            "address",
                            _vm.addressLanguages
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["common.language"]))]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["basedata.remark"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: { maxLength: _vm.maxLength.remark },
                    model: {
                      value: _vm.model.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "remark", $$v)
                      },
                      expression: "model.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.costCode"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.model.costCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "costCode", $$v)
                      },
                      expression: "model.costCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: {
                    label:
                      _vm.language["PlatForm.employee.columns.factoryName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.model.factoryName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "factoryName", $$v)
                      },
                      expression: "model.factoryName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: {
                    label: _vm.language["PlatForm.employee.columns.empClass"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.model.empClass,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "empClass", $$v)
                      },
                      expression: "model.empClass"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: {
                    label:
                      _vm.language["PlatForm.employee.columns.companyName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.model.companyName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "companyName", $$v)
                      },
                      expression: "model.companyName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _vm.model.isUser === "1"
                    ? _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language[
                                "PlatForm.employee.columns.selectedAppids"
                              ],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("j-multi-select-tag", {
                            attrs: { options: _vm.appsOptions, disabled: true },
                            model: {
                              value: _vm.model.selectedAppids,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "selectedAppids", $$v)
                              },
                              expression: "model.selectedAppids"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("a-col", {
                staticStyle: { height: "50px" },
                attrs: { span: 24 }
              })
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disableSubmit,
              expression: "!disableSubmit"
            }
          ],
          staticClass: "drawer-bootom-button"
        },
        [
          _c(
            "a-popconfirm",
            {
              attrs: {
                title: _vm.language["message.giveUpEditing"],
                okText: _vm.language["common.determineButton"],
                cancelText: _vm.language["common.cancel"]
              },
              on: { confirm: _vm.handleCancel }
            },
            [
              _c("a-button", { staticStyle: { "margin-right": ".8rem" } }, [
                _vm._v(_vm._s(_vm.language["common.cancel"]))
              ])
            ],
            1
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.language["common.submitButton"]))]
          )
        ],
        1
      ),
      _c("j-select-depart-modal-by-application", {
        ref: "departSelectModalByApplication",
        on: { ok: _vm.loadselectDeport }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }